import { useState } from 'react';

const testimonials = [
  {
    quote:
      'I was ready to give up on my tree after a failed upgrade. One chat session and they had me back within the hour—backup restored and sync working again.',
    name: 'Margaret L.',
    location: 'Portland, OR',
  },
  {
    quote:
      'Moving FTM to a new laptop felt overwhelming until support walked me through backup and restore. Every photo and note came across perfectly.',
    name: 'David R.',
    location: 'Nashville, TN',
  },
  {
    quote:
      'TreeVault kept failing to sync. Chat support pinpointed the issue in minutes and gave me steps I could actually follow on my Mac.',
    name: 'Susan W.',
    location: 'Denver, CO',
  },
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const current = testimonials[currentIndex];

  return (
    <section className="t7-section t7-section--white">
      <div className="container">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-8 lg:gap-16 items-start lg:items-end">
          <div className="t7-head t7-head--rail mb-0">
            <p className="t7-kicker">Experiences</p>
            <h2 className="t7-title">What users tell us</h2>
            <p className="t7-lead mb-5 md:mb-6">
              Feedback from people who got their Family Tree Maker projects back on track.
            </p>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
                className="h-11 w-11 border border-[#c4d4ca] rounded-[10px] text-[#2d6a4f] hover:bg-[#d8f3dc] transition-colors touch-manipulation"
                aria-label="Previous testimonial"
              >
                ←
              </button>
              <button
                type="button"
                onClick={() => setCurrentIndex((prev) => (prev + 1) % testimonials.length)}
                className="h-11 w-11 border border-[#c4d4ca] rounded-[10px] text-[#2d6a4f] hover:bg-[#d8f3dc] transition-colors touch-manipulation"
                aria-label="Next testimonial"
              >
                →
              </button>
            </div>
          </div>

          <blockquote className="bg-[#e6efe9] border-l-4 border-[#c9956a] rounded-r-[10px] p-5 sm:p-8 md:p-10 m-0">
            <p className="font-serif text-lg sm:text-xl md:text-2xl text-[#152019] leading-snug mb-6 md:mb-8">
              &ldquo;{current.quote}&rdquo;
            </p>
            <footer className="flex items-start sm:items-center justify-between gap-3 flex-wrap">
              <cite className="not-italic font-semibold text-[#2d6a4f] text-sm sm:text-base">
                {current.name}
                <span className="font-normal text-[#55665c]"> — {current.location}</span>
              </cite>
              <div className="flex gap-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => setCurrentIndex(index)}
                    className={`h-2.5 w-2.5 rounded-full transition-colors touch-manipulation ${
                      index === currentIndex ? 'bg-[#2d6a4f]' : 'bg-[#c4d4ca]'
                    }`}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
